import { PublicEvent, PublicEvents } from 'utils/publicEvents/events';

const create = (): PublicEvent => ({
  name: PublicEvents.USER_LOGGED_OUT,
  data: {},
});

const exportObject = {
  create,
};

export default exportObject;
